import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultLoginComponent } from './components';
import { CanDeactivateLoginService, CanActiveLoginService } from './services/guard';
import { LoginService } from './services';
import { LoginRoutingModule } from './login-routing.module';
import { Common2Module } from 'projects/common/src/app/app.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { communicationServiceProvider } from './services/providers';
import { LogoModule } from '../logo/logo.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DomErrorInterceptorService, ErrorInterceptorService } from 'projects/communication/src/app/services/interceptors';
import { FooterModule } from '../footer/footer.module';
import { CoreModule } from '../core/core.module';
import { UnauthorizedInterceptorService } from './services/interceptors';

@NgModule({
  providers: [
    LoginService,
    CanActiveLoginService,
    CanDeactivateLoginService,
    communicationServiceProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DomErrorInterceptorService,
      multi: true
    },
  ],
  declarations: [
    DefaultLoginComponent,
  ],
  imports: [
    CommonModule,
    Common2Module.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    LoginRoutingModule,
    LogoModule,
    FooterModule,
    CoreModule
  ],
  exports: [
    DefaultLoginComponent
  ]
})
export class LoginModule { }
